import { render, staticRenderFns } from "./Sofa.vue?vue&type=template&id=3ee29e79&scoped=true"
import script from "./Sofa.vue?vue&type=script&lang=js"
export * from "./Sofa.vue?vue&type=script&lang=js"
import style0 from "./Sofa.vue?vue&type=style&index=0&id=3ee29e79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee29e79",
  null
  
)

export default component.exports